import Vue from 'vue';

import Vuelidate from 'vuelidate';
// import Vuetify from 'vuetify';
//import Vuetify from 'vuetify/lib';
import VueProgressBar from 'vue-progressbar';
import vuemask from 'vue-the-mask';
import VueCharts from 'vue-chartjs';
import vueDebounce from 'vue-debounce'
import VueTour from 'vue-tour';


import router from './routes';

import store from './store/index';
import GlobalPlugin from './plugins';
import App from './App.vue';
import './assets/css/fonts.css';
import './assets/css/sigedalert.scss';
import './assets/css/main.scss';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'animate.css/animate.min.css';
import 'babel-polyfill';

import 'vue-tour/dist/vue-tour.css';
import vuetify from './plugins/vuetify'
// import vuetify from './plugins/vuetify3'

// const opts= {}
// const vuetify = new Vuetify(opts)

Vue.use(Vuelidate);
Vue.use(vueDebounce);
Vue.use(vuemask);
Vue.use(VueCharts);
// Vue.use(Vuetify, {
//   theme: {
//     'tool-bar-app': '#5492C1',
//     'nav-bar': '#508fbf',
//     'nav-bar-sub': '#5492C1',
//     second: '#009688',
//     accent: '#25848c',
//     'table-head': '#2196f3',
//     // 'table-hover': '#2497f326',
//   },
// });

Vue.use(GlobalPlugin);
Vue.use(VueProgressBar, {
  color: '#e7e7e7',
  failedColor: 'red',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  inverse: false,
  iconfont: 'mdi',
});
Vue.use(VueTour);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
